import React, { Component } from 'react';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import SalesTargetCreateModalUI from './SalesTargetCreateModalUI';

class SalesTargetCreateModalSF extends Component {
    constructor(props) {
        super(props);
        this.state = {
            successMsg: null,
            errorList: null,
            submitted: false,
            userId: '',
            userIdError: null,
            month: '',
            monthError: null,
            year: '',
            yearError: null,
            channel: '',
            channelError: null,
            noOfContacts: '',  
            noOfContactsError: null,  
            newLeadTarget: '',
            newLeadTargetError: null,
            newDisbTarget: '',
            newDisbTargetError: null,
            numberOfCustomers:'',
            numberOfCustomersError:null,
            contactsAchieved: '',
            contactsAchievedError: null,
            newLeadAchieved: '',
            newLeadAchievedError: null,
            newDisbAchieved: '',
            newDisbAchievedError: null,
            customersAchieved: '',
            customersAchievedError: null,

        };
    }

    render() {
        return (
            <SalesTargetCreateModalUI
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                setErrorList={this.setErrorList}
                onSubmit={this.onSubmit}
                onCancelClick={this.props.onCreateSalesTargetCancel}
                createMode={this.props.salesTargetCreateMode}
                submitted={this.state.submitted}

                //
                userId={this.state.userId}
                onUserIdChange={(event) => this.setState({ userId: event.target.value })}
                userIdError={this.state.userIdError}
                setUserIdError={(error) => this.setState({ userIdError: error })}
                userIdList={this.props.userIdList}
                //
                month={this.state.month}
                onMonthChange={(event) => this.setState({ month: event.target.value })}
                monthError={this.state.monthError}
                setMonthError={(error) => this.setState({ monthError: error })}
                monthList={this.props.monthList}
                //
                year={this.state.year}
                onYearChange={(event) => this.setState({ year: event.target.value })}
                yearError={this.state.yearError}
                setYearError={(error) => this.setState({ yearError: error })}
                yearList={this.props.yearList}

                // channel
                channel={this.state.channel}
                onChannelChange={(event) => this.setState({ channel: event.target.value })}
                channelError={this.state.channelError}
                setChannelError={(error) => this.setState({ channelError: error })}
                salesChannelList={this.props.salesChannelList}
                //
                noOfContacts={this.state.noOfContacts}  
                onNoOfContactsChange={(event) => this.setState({ noOfContacts: event.target.value })}  
                noOfContactsError={this.state.noOfContactsError}  
                setNoOfContactsError={(error) => this.setState({ noOfContactsError: error })}    
                //
                newLeadTarget={this.state.newLeadTarget}
                onNewLeadTargetChange={(event) => this.setState({ newLeadTarget: event.target.value })}
                newLeadTargetError={this.state.newLeadTargetError}
                setNewLeadTargetError={(error) => this.setState({ newLeadTargetError: error })}
                //
                newDisbTarget={this.state.newDisbTarget}
                onNewDisbTargetChange={(event) => this.setState({ newDisbTarget: event.target.value })}
                newDisbTargetError={this.state.newDisbTargetError}
                setNewDisbTargetError={(error) => this.setState({ newDisbTargetError: error })}
                //
                numberOfCustomers={this.state.numberOfCustomers}
                onNumberOfCustomersChange={(event) => this.setState({ numberOfCustomers: event.target.value })}
                numberOfCustomersError={this.state.numberOfCustomersError}
                setNumberOfCustomersError={(error) => this.setState({ numberOfCustomersError: error })}
                //
                contactsAchieved={this.state.contactsAchieved}
                onContactsAchievedChange={(event) => this.setState({ contactsAchieved: event.target.value })}
                contactsAchievedError={this.state.contactsAchievedError}
                setContactsAchievedError={(error) => this.setState({ contactsAchievedError: error })}
                //
                newLeadAchieved={this.state.newLeadAchieved}
                onNewLeadAchievedChange={(event) => this.setState({ newLeadAchieved: event.target.value })}
                newLeadAchievedError={this.state.newLeadAchievedError}
                setNewLeadAchievedError={(error) => this.setState({ newLeadAchievedError: error })}
                //
                newDisbAchieved={this.state.newDisbAchieved}
                onNewDisbAchievedChange={(event) => this.setState({ newDisbAchieved: event.target.value })}
                newDisbAchievedError={this.state.newDisbAchievedError}
                setNewDisbAchievedError={(error) => this.setState({ newDisbAchievedError: error })}
                //
                customersAchieved={this.state.customersAchieved}
                onCustomersAchievedChange={(event) => this.setState({ customersAchieved: event.target.value })}
                customersAchievedError={this.state.customersAchievedError}
                setCustomersAchievedError={(error) => this.setState({ customersAchievedError: error })}


            />
        );
    }

    componentDidMount() {
        Modal.setAppElement('body');
    }

    onCreateSalesTargetCancel = () => {
        this.setState({
            successMsg: null,
            errorList: null,
            userId: '',
            year: '',
            month: '',
            channel: null,
            noOfContacts: '',    
            newLeadTarget: '',
            newDisbTarget: '',
            numberOfCustomers:'',
            contactsAchieved: '',
            newLeadAchieved: '',
            newDisbAchieved: '',
            customersAchieved: ''

        });
        this.props.onCreateSalesTargetCancel();
    };

    onSubmit = () => {
        if (this.state.submitted) return;
        this.setState({ successMsg: null, errorList: [], submitted: true });
        RestApiUtils.post(
            this.props.context,
            `/api/su/sales/targets/users/${this.state.userId}`,
            this.onSubmitCallback,
            {
                userId: this.state.userId,
                year: this.state.year,
                month: this.state.month,
                channel: this.state.channel,
                noOfContacts: this.state.noOfContacts,  
                newLeadTarget: this.state.newLeadTarget,
                newDisbTarget: this.state.newDisbTarget,
                numberOfCustomers: this.state.numberOfCustomers,
                contactsAchieved: this.state.contactsAchieved,
                newLeadAchieved: this.state.newLeadAchieved,
                newDisbAchieved: this.state.newDisbAchieved,
                customersAchieved: this.state.customersAchieved,
            }
        );
    };

    onSubmitCallback = (response) => {
        let errorList = [];
        if (response && response.errorList) {
            response.errorList.forEach((error) => errorList.push(error.message));
        }
        this.setState({ successMsg: response.success, errorList: errorList, submitted: false });
        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({ successMsg: null });
                this.props.onCreateSalesTargetCancel();
                this.props.onRefreshClick();
            }, 2000);
        }
    };

    setErrorList = (errorList) => {
        this.setState({ errorList: errorList });
    };
}

export default withRouter(SalesTargetCreateModalSF);
